import { SearchIcon } from "Layout/icons/SearchIcon";
import React from "react";
import { cn } from "utils";

type SearchBoxProps = {
  value: string;
  placeholder?: string;
  className?: string;
  onChange: (value: string) => void;
};

export const SearchBox = ({
  value,
  onChange,
  placeholder,
  className,
}: SearchBoxProps) => {
  return (
    <div
      className={cn(
        "flex gap-1 items-center relative max-h-[44px] min-h-[44px] bg-white w-full border duration-300 border-[#d3d3d3] focus:border-primary-light rounded-md",
        className
      )}>
      <div className="flex justify-center items-center px-3">
        <SearchIcon className="relative top-0 left-0" />
      </div>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full h-full bg-transparent outline-none border-none flex-1"
      />
    </div>
  );
};
